import cn from 'classnames';
import React from 'react';
import ReactAudioPlayer from 'react-h5-audio-player';

interface Props {
  src: string;
  className?: string;
}

export const AudioPlayer = ({ src, className }: Props) => (
  <ReactAudioPlayer
    autoPlayAfterSrcChange={false}
    src={src}
    className={cn(className, 'rounded-xl border-[1px] border-[#9CDFFC]')}
  />
);
